import _ from 'underscore';
import levenstein from 'levenshtein-edit-distance';

export class PagesSearchEngine {
  constructor({ searchItemsTreeRoot, i18n }) {
    _.extend(this, { searchItemsTreeRoot, i18n });
  }

  resolveName = node => this.i18n.getString(node.searchAlias || node.name)

  sortResults = (array, searchQuery) => {
    const primaryGroup = [];
    const secondaryGroup = [];
    const remainingMatches = [];

    _.forEach(array, (node) => {
      const name = this.resolveName(node).toLowerCase();
      const queryIndex = name.indexOf(searchQuery);
      if (queryIndex === 0) {
        primaryGroup.push(node);
      } else if (name.charAt(queryIndex - 1) === ' ') {
        secondaryGroup.push(node);
      } else {
        remainingMatches.push(node);
      }
    });
    const currentLocale = this.i18n.getLocale();
    const compareLocale = new Intl.Collator(currentLocale).compare;
    const sortingMethod = (a, b) => compareLocale(a.name, b.name);
    primaryGroup.sort(sortingMethod);
    secondaryGroup.sort(sortingMethod);
    remainingMatches.sort(sortingMethod);

    return [...primaryGroup, ...secondaryGroup, ...remainingMatches];
  }

  traverseSearchItemsTreeAndSearch(node, searchQuery) {
    // leaf node, let's do the search
    if (_.isEmpty(node.children)) {
      if (!_.result(node, 'searchable', true)) {
        return [];
      }
      let threshold = 2;
      if (this.resolveName(node).length <= 3) {
        threshold = 0;
      }
      if (levenstein(this.resolveName(node), searchQuery, true) <= threshold ||
        this.resolveName(node).toLowerCase().indexOf(searchQuery) > -1) {
        return [node];
      }
      return [];
    }

    const childrenResults = node.children.map((child) => {
      const ret = this.traverseSearchItemsTreeAndSearch(
        child,
        searchQuery
      );

      return ret;
    });

    return childrenResults.reduce((array1, array2) => array1.concat(array2), []);
  }

  search(originalQuery) {
    if (_.isEmpty(originalQuery)) {
      return [];
    }
    const searchQuery = originalQuery.toLowerCase();
    const searchResults = this.traverseSearchItemsTreeAndSearch(
      this.searchItemsTreeRoot,
      searchQuery
    );

    const sortedResults = this.sortResults(searchResults, searchQuery);
    return this.handleDuplicates(sortedResults);
  }

  handleDuplicates(searchResults) {
    let resultNodesByName = {};

    searchResults.forEach((searchResult) => {
      const nameLowerCase = this.resolveName(searchResult).toLowerCase();
      if (!_.isArray(resultNodesByName[nameLowerCase])) {
        resultNodesByName[nameLowerCase] = [];
      }

      resultNodesByName[nameLowerCase].push(searchResult);
    });

    resultNodesByName = _.values(resultNodesByName).map((list) => {
      if (list.length === 1) {
        const item = list[0];
        return { ...item, name: this.resolveName(item) };
      }

      return list.map(item => (
        {
          ...item,
          name: item.parent
            ? `${this.resolveName(item.parent)} > ${this.resolveName(item)}`
            : this.resolveName(item),
        }));
    });

    return _.values(resultNodesByName).reduce((a, b) => a.concat(b), []);
  }
}
